import { api } from '../http';

export const saveConfigurations = (companyId, configurationsData) =>
  api.post(`/companies/${companyId}/configurations`, configurationsData);
export const searchConfigurations = companyId => api.get(`/companies/${companyId}/configurations`);
